import { useState, useEffect } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import "./profile.css";

export default function EmergencyContact({ personal, onSave, saving }) {
  const [form, setForm] = useState({
    emergency_contact_name: personal.emergency_contact_name || "",
    emergency_contact_number: personal.emergency_contact_number || "",
  });

  useEffect(() => {
    setForm({
      emergency_contact_name: personal.emergency_contact_name || "",
      emergency_contact_number: personal.emergency_contact_number || "",
    });
  }, [personal.emergency_contact_name, personal.emergency_contact_number]);

  const handleSave = async () => {
    await onSave(form);
  };

  const hasExisting =
    personal.emergency_contact_name || personal.emergency_contact_number;

  return (
    <div className="account-card">
      <h2>Emergency Contact</h2>

      <div className="form-section-card security-section">
        <div className="section-title-premium">
          <FaPhoneAlt /> {hasExisting ? "Update Emergency Contact" : "Add Emergency Contact"}
        </div>

        <div className="grid-2">
          <div className="account-field">
            <label>Contact Name</label>
            <input
              type="text"
              value={form.emergency_contact_name}
              placeholder="Primary contact name"
              onChange={(e) =>
                setForm({ ...form, emergency_contact_name: e.target.value })
              }
            />
          </div>

          <div className="account-field">
            <label>Contact Number</label>
            <input
              type="tel"
              value={form.emergency_contact_number}
              placeholder="Primary contact phone"
              onChange={(e) =>
                setForm({ ...form, emergency_contact_number: e.target.value })
              }
            />
          </div>
        </div>

        <button
          className="account-save-btn security-save-btn"
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? (
            <>
              <span className="btn-spinner" />
              Saving…
            </>
          ) : hasExisting ? (
            "Update Emergency Contact"
          ) : (
            "Save Emergency Contact"
          )}
        </button>
      </div>
    </div>
  );
}